import React from "react";
import get from "lodash/get";
import { withNamespaces } from "react-i18next";
import FileLink from "../FileLink/FileLink";
import { getUserToken } from "../../reducers/user/selectors";
import { connect } from "react-redux";

const ConsentLhsStep4 = (props) => {
  return (
    <div className="form-group">
      <div className="form-group-details">
        <h4>
          {props.consentExistsEmailStatus !== 'all_signatures_collected' &&
          ["WithdrawConsentEmail", "Email", "EmailRegainedCapacity"].includes(
            get(props, "consentMethodType")
          )
            ? `Confirmation - E-mail Consent has been sent to ${props.email_consent_signature_order === 'subject_first' ? 'investigator' : 'patient'} for signature!`
            : props.i18n.t(
                "NamespaceConsentLhsStep4:Confirmation - Consent has been provided!"
              )}
        </h4>
        {props.siteID && (
          <h5>
            {props.i18n.t("Site ID")}: <b>{props.siteID}</b>
          </h5>
        )}
        {props.userID && (
          <h5>
            {props.i18n.t("User ID")}: <b>{props.userID}</b>
          </h5>
        )}
        <h5>
          {props.i18n.t("Subject ID")}: <b>{props.subjectID}</b>
        </h5>
        <h5>
          {props.i18n.t("Consent Type")}: <b>{props.consentPersonType}</b>
        </h5>
        <h5>
          {props.i18n.t("Consent Method")}: <b>{props.consentMethodType}</b>
        </h5>

        {props.consent_version && (
          <h5 style={{ display: "inline-block !important" }}>
            {props.i18n.t("Consent Version")}: <b>{props.consent_version}</b>
          </h5>
        )}
        {props.consentExistsOption && (
          <h5 style={{ display: "inline-block !important" }}>
            {props.i18n.t("Consent Options")}:{" "}
            <b>{props.consentExistsOption.replace(/_/g, " ")}</b>
          </h5>
        )}

        {["WithdrawConsentEmail", "Email", "EmailRegainedCapacity"].includes(
          props.consentExistsMethodType
        ) &&
          props.consentExistsEmailStatus && (
            <h5>
              {props.i18n.t("NamespaceConsentLhsStep4:Consent Email Status")}:{" "}
              <b>{props.consentExistsEmailStatus.replace(/_/g, " ")}</b>
            </h5>
          )}
        {props.token &&
          props.consentExistsLink &&
          (Array.isArray(props.consentExistsLink) ? (
            props.consentExistsLink.map(({ link, name }) => (
            link ? <h5>
                {props.i18n.t("Document Link")}:{" "}
                <b style={{ position: "relative", top: "8px" }}>
                  <FileLink url={link} text={name} />
                </b>
              </h5> : <div />
            ))
          ) : (
          props.consentExistsLink.link ? <h5>
              {props.i18n.t("Document Link")}:{" "}
              <b style={{ position: "relative", top: "8px" }}>
                <FileLink
                  url={props.consentExistsLink.link}
                  text={props.consentExistsLink.name}
                />
              </b>
            </h5> : <div/>
          ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: getUserToken(state),
});

export default connect(mapStateToProps)(withNamespaces()(ConsentLhsStep4));



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLhs/ConsentLhsStep4.js